class ProductInfoTabs extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (!this.buttons.length) return;

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.activate(button));
      button.addEventListener('keydown', (event) => this.onKeydown(event));
    });
  }

  activate(button) {
    this.buttons.forEach((item) => {
      const selected = item === button;
      item.setAttribute('aria-selected', selected);
      item.setAttribute('tabindex', selected ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      const selected = panel.id === button.getAttribute('aria-controls');
      panel.classList.toggle('is-active', selected);
      panel.hidden = !selected;
    });
  }

  onKeydown(event) {
    const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (!keys.includes(event.key)) return;

    event.preventDefault();
    const index = this.buttons.indexOf(event.currentTarget);
    let next = index;

    if (event.key === 'ArrowRight') next = (index + 1) % this.buttons.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + this.buttons.length) % this.buttons.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = this.buttons.length - 1;

    this.buttons[next].focus();
    this.activate(this.buttons[next]);
  }
}

customElements.define('product-info-tabs', ProductInfoTabs);
